<template>
  <div>
    <ag-grid-vue style='width: 100%; height: 600px;' class='ag-theme-balham-dark'
                 :gridOptions='gridOptions'
                 :enableColResize="true"
                 :showToolPanel="showToolPanel"
                 :rowData="records"
                 :enableSorting="true"
                 :suppressClickEdit="true"
                 :enableFilter="true"
                 :groupHeaders="true"
                 :suppressRowClickSelection="true"
>
    </ag-grid-vue>
  </div>
</template>
<script>
  import {AgGridVue} from 'ag-grid-vue'
  import moment from 'moment'
  import {DefaultGridOptions} from "@/default_table_settings";
  import {applyGridPersistence} from "@/grid_persistence"

  export default {
    props: ['records', 'server'],
    data () {
      return {
        gridOptions: null,
        showToolPanel: false,
        suppressMovable: true
      }
    },
    components: {
      'ag-grid-vue': AgGridVue
    },
    methods: {
      createRowData () {
        return this.records
      },
      onGridSizeChanged () {
        this.gridOptions.api.sizeColumnsToFit()
      },
      createColumnDefs () {
        return [
          {
            headerName: 'Guild Left',
            field: 'left',
            filter: 'agSetColumnFilter'
          },
          {
            headerName: 'Guild Joined',
            field: 'joined',
            filter: 'agSetColumnFilter'
          },
          {
            headerName: 'Date',
            field: 'date',
            sort: 'desc',
            filter: 'agDateColumnFilter',
            suppressFilter: true,
            cellRenderer: params => this.formatDateDisplay(params.value),
            tooltipValueGetter: params => {
              if (!params.value) return '';
              const m = moment(params.value);
              return `Local: ${m.local().format('YYYY-MM-DD HH:mm:ss')}`;
            }
          }
        ]
      }
    },
    beforeMount () {
      this.gridOptions = Object.assign({}, DefaultGridOptions, {
        suppressRowClickSelection: true,
        rowSelection: 'multiple'
      })
      applyGridPersistence(this.gridOptions, 'user-guild-grid')
      this.gridOptions.rowData = this.createRowData()
      this.gridOptions.columnDefs = this.createColumnDefs()
    },
    mounted () {
    }
  }
</script>

<style>
</style>
